import React from 'react';
import { Award, Users, CheckCircle, TrendingUp } from 'lucide-react';
import { companyInfo } from '../mock/data';

const About = () => {
  const stats = [
    { icon: Award, label: 'Years Experience', value: companyInfo.yearsOfExperience },
    { icon: Users, label: 'Happy Clients', value: '500+' },
    { icon: CheckCircle, label: 'Projects Completed', value: '1000+' },
    { icon: TrendingUp, label: 'Customer Satisfaction', value: '100%' }
  ];

  const features = [
    'Premium quality glass and aluminum materials',
    'Expert installation by certified professionals',
    'Custom designs tailored to your needs',
    'Competitive pricing with transparent quotes',
    'Full warranty on all installations',
    'Serving the entire Lower Mainland, BC'
  ];

  return (
    <section id="about" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://customer-assets.emergentagent.com/job_polosi-railings/artifacts/9nk9bie6_IMG_4361.jpeg"
                alt="Professional Glass Railing Installation"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
            </div>
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-blue-600 text-white p-8 rounded-2xl shadow-xl">
              <div className="text-5xl font-bold">{companyInfo.yearsOfExperience}</div>
              <div className="text-sm font-medium mt-1">Years of Excellence</div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div>
            <div className="mb-6 flex items-center gap-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_polosi-railings/artifacts/l0a8bsyg_c35df9ca56d27f2c01ab1bb017420a8c790577e9c9899e8e06f1f612eaec8253.png"
                alt="AP Glass Railings Logo"
                className="h-20 w-auto"
              />
              <div>
                <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">About Us</span>
                <div className="w-20 h-1 bg-blue-600 mt-1"></div>
              </div>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
              Crafting Excellence in Every Installation
            </h2>

            <p className="text-lg text-slate-700 mb-6 leading-relaxed">
              {companyInfo.description}
            </p>

            <p className="text-slate-600 mb-8 leading-relaxed">
              Founded by {companyInfo.owner}, {companyInfo.name} has built a reputation for 
              delivering exceptional quality and service. We specialize in both glass and aluminum 
              railing systems, bringing modern elegance and safety to residential and commercial properties.
            </p>

            {/* Features List */}
            <div className="grid sm:grid-cols-2 gap-4 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="h-6 w-6 text-blue-600 flex-shrink-0 mt-0.5" />
                  <span className="text-slate-700">{feature}</span>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-12">
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <div key={index} className="text-center">
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 rounded-lg mb-3">
                      <Icon className="h-6 w-6 text-blue-600" />
                    </div>
                    <div className="text-2xl font-bold text-slate-900">{stat.value}</div>
                    <div className="text-sm text-slate-600 mt-1">{stat.label}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
